<template>
  <div class="showcase-home-hero">
    <div class="container">
      <div class="content">
        <ShowcaseHeader />
        <transition :name="transitionName" mode="out-in">
          <component :is="currentStep.component"></component>
        </transition>
        <ShowcaseHomeHeroFooter />
      </div>
    </div>
    <canvas class="canvas" data-js-darken-top data-transition-in></canvas>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { Gradient } from './scripts/gradient';
import ShowcaseHeader from '@/showcase/components/showcase-header';
import ShowcaseHomeHeroContent from '@/showcase/home/components/showcase-home-hero-content';
import ShowcaseHomeHeroFooter from '@/showcase/home/components/showcase-home-hero-footer';
import ShowcaseHomeHeroValidate from '@/showcase/home/components/showcase-home-hero-validate';
import ShowcaseHomeHeroRegister from '@/showcase/home/components/showcase-home-hero-register';
import ShowcaseHomeHeroComplete from '@/showcase/home/components/showcase-home-hero-complete';
import ShowcaseHomeHeroLogin from '@/showcase/home/components/showcase-home-hero-login';
import ShowcaseHomeHeroWxLogin from '@/showcase/home/components/showcase-home-hero-wxlogin';

export default defineComponent({
  name: 'ShowcaseHomeHero',

  /**
   * 属性
   */
  props: {},

  /**
   * 数据
   */
  data() {
    return {
      transitionName: '',
    };
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      currentStep: 'invite/currentStep',
      currentStepName: 'invite/currentStepName',
    }),
  },

  /**
   * 监视
   */
  watch: {
    async $route(newValue) {
      if (newValue.query.step) {
        const { step } = newValue.query;
        const isValidStep = await this.verifySteps(step);
        if (!(this.currentStepName === step) && isValidStep) {
          this.setCurrentStepName(step);
        }
      }

      if (newValue.name === 'showcaseHome' && !newValue.query.step) {
        if (this.currentStepName !== 'initial') {
          this.setCurrentStepName('initial');
        }
      }
    },
  },

  /**
   * 已创建
   */
  created() {
    //
    setTimeout(() => {
      this.transitionName = 'showcase-hero-content';
    }, 500);
  },

  /**
   * 已挂载
   */
  mounted() {
    /*
     * 暂停：Gradient.pause()
     * 开始：Gradient.play()
     *
     * 振幅: Gradient.amp = 0
     * 颜色: Gradient.sectionColors (使用 normalizeColor(#hexValue))
     *
     * Gradient.toggleColor(index)
     * Gradient.updateFrequency(freq)
     */

    const gradient = new Gradient();
    gradient.initGradient('.showcase-home-hero > .canvas');
    // gradient.amp = 10;
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapMutations({
      setCurrentStepName: 'invite/setCurrentStepName',
    }),

    ...mapActions({
      verifySteps: 'invite/verifySteps',
    }),
  },

  /**
   * 使用组件
   */
  components: {
    ShowcaseHomeHeroWxLogin,
    ShowcaseHomeHeroLogin,
    ShowcaseHomeHeroComplete,
    ShowcaseHomeHeroRegister,
    ShowcaseHomeHeroValidate,
    ShowcaseHomeHeroFooter,
    ShowcaseHomeHeroContent,
    ShowcaseHeader,
  },
});
</script>

<style scoped>
@import './styles/showcase-home-hero.css';
</style>
